import type { ProductVariantPanelAttributes } from '../../types/cms'
import { ProductVariantPanelContainer } from './styles'
import { Container } from '@mui/material'
import FormattedImage from '../FormattedImage'
import { MarkdownText } from 'ui-kit'

const ProductVariantPanel = ({
  title,
  info,
  images,
}: ProductVariantPanelAttributes) => {
  return (
    <ProductVariantPanelContainer>
      <Container maxWidth="lg" sx={{ marginBottom: '2rem' }}>
        <MarkdownText>{title}</MarkdownText>
        <MarkdownText>{info}</MarkdownText>
      </Container>
      <Container maxWidth="xl">
        {images?.data?.map(image => (
          <FormattedImage image={{ data: image }} key={image.id} />
        ))}
      </Container>
    </ProductVariantPanelContainer>
  )
}

export default ProductVariantPanel
